import * as bookingList from './BookingListAction';

export const bookingListAction = bookingList;